import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Grid } from "@mui/material";
import { textFieldStyle } from "../../../assets/styles/styles";
import { ContactPopup } from "./Contact";
import { wwwRoutes } from "../../../variables/wwwRoutes";
import { useLocation } from "react-router-dom";
import { sendContactInfoStore } from "../../../stores/sendContactInfoStore";
export const ContactButton = () => {
    const location = useLocation();
    if (location.pathname === wwwRoutes.contact)
        return _jsx(_Fragment, {}, void 0);
    return (_jsxs(Grid, { item: true, children: [_jsx(Grid, { container: true, alignItems: 'center', sx: { ...textFieldStyle, height: '100%' }, children: _jsx(Button, { onClick: sendContactInfoStore.openContact, sx: { textTransform: 'none' }, children: "Contact" }, void 0) }, void 0), _jsx(ContactPopup, {}, void 0)] }, void 0));
};
//# sourceMappingURL=ContactButton.js.map